import { useRuntimeConfig } from "nuxt/app";
import { useAuthState } from "../states/auth.js";
import { useAuth } from "./use-auth.js";
export function useAuthFetch(request, opts) {
  const { requestNewToken } = useAuth();
  const { accessTokenState } = useAuthState();
  const config = useRuntimeConfig();
  return $fetch(request, {
    ...opts,
    baseURL: config.public.host,
    async onRequest(data) {
      if (accessTokenState.value) {
        data.options.headers = {
          ...data.options.headers,
          Authorization: `Bearer ${accessTokenState.value}`
        };
      }
    },
    onResponseError: async () => {
      await requestNewToken();
    },
    retry: 3,
    retryDelay: 500,
    retryStatusCodes: [401]
  });
}
